import { CoreAutocomplete, CoreTextField } from "@verity/components/core";
import { ProctoringOptionProfileV2 } from "@verity/proctoring-option/types";
import i18n from "../../../../i18n";

export function ProfileSearchSelect({
	profiles,
	selectedProfile,
	setSelectedProfile,
	searchInput,
	setSearchInput,
	onClickSelect,
}: {
	profiles: Array<ProctoringOptionProfileV2>;
	selectedProfile: ProctoringOptionProfileV2 | undefined;
	setSelectedProfile: (profile: ProctoringOptionProfileV2 | undefined) => void;
	searchInput: string;
	setSearchInput: (input: string) => void;
	onClickSelect?: (profile: ProctoringOptionProfileV2 | undefined) => void;
}) {
	const sortedProfiles = [...profiles].sort((a, b) =>
		(a.name ?? "").toLocaleLowerCase().localeCompare((b.name ?? "").toLowerCase()),
	);
	return (
		<CoreAutocomplete
			disableClearable
			value={selectedProfile}
			inputValue={searchInput}
			options={sortedProfiles}
			getOptionLabel={(option) => (typeof option === "string" ? option : (option?.name ?? ""))}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			renderOption={(props, option) => (
				<li {...props} key={option.id}>
					{option.name}
				</li>
			)}
			sx={{ width: "100%" }}
			onInputChange={(_e, newValue) => setSearchInput(newValue)}
			onChange={(_e, newValue) => {
				if (typeof newValue === "object") {
					const selectedValue = newValue as ProctoringOptionProfileV2 | null;
					setSelectedProfile(selectedValue ?? undefined);
					setSearchInput(selectedValue?.name ?? "");
					onClickSelect?.(selectedValue ?? undefined);
				}
			}}
			renderInput={(params) => (
				<CoreTextField
					{...params}
					label={i18n.t("portal.components.settings.instituteGlobalProfile.indexTSX.selectProfile")}
				/>
			)}
		/>
	);
}
